<template>
  <div class="shadow p-3 mx-auto my-5 rounded-8 w-75 bg-white">
    <h2 class="p-3 text-primary">{{ props.title }}</h2>
    <div v-if="props.originalObjectsArray.length === 0" class="p-3 text-primary mb-5">
      {{ t('analysts.requests.noRequests') }}
    </div>
    <div class="p-3" v-else>
      <div class="mb-4">
        <SearchBarV2
          :placeholder="searchBarPlaceholder"
          :modelValue="props.currentSearch"
          :currentSearch="props.currentSearch"
          @update:modelValue="$emit('search-change', $event)"
        />
      </div>
      <RequestsTable
        :paginatedObjects="props.originalObjectsArray"
        :fromView="props.fromView"
      />
      <div class="text-center">
        <VueAwesomePaginate
          :modelValue="props.currentPage"
          :total-items="props.totalCount"
          :items-per-page="nEntries"
          :max-pages-shown="8"
          @update:modelValue="$emit('page-change', $event)"
          :back-button-class="props.currentPage === 1 ? 'd-none' : 'back-button'"
          :next-button-class="props.currentPage === Math.ceil(props.totalCount / nEntries) ? 'd-none' : 'next-button'"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from 'vue'
import RequestsTable from '@/components/RequestsTable.vue'
import SearchBarV2 from '@/components/SearchBarV2.vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const props = defineProps({
  title: String,
  fromView: String,
  originalObjectsArray: Array,
  totalCount: Number,
  currentPage: {
    type: Number,
    required: true
  },
  currentSearch: String
})

const nEntries = 4

let searchBarPlaceholder = ''
switch (props.fromView) {
  case 'testRequests':
    searchBarPlaceholder = `${t('analysts.requests.searchByCandidate')}...`
    break
  case 'candidateRequests':
    searchBarPlaceholder = `${t('analysts.requests.searchByTest')}...`
    break
  case 'requests':
    searchBarPlaceholder = `${t('analysts.requests.searchByCandidate')}...`
    break
}

</script>
